import React, { useEffect, useState } from "react";
import {
  Button, Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem,
  Paper, Select, Table, TableBody, TableCell, TableHead, TableRow,
  TextField, Typography, makeStyles
} from "@material-ui/core";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
  content: { padding: theme.spacing(2), overflowY: "auto" },
  form: { display: "flex", gap: 10, padding: theme.spacing(2), marginBottom: theme.spacing(2), flexWrap: "wrap", alignItems: "center" },
  input: { minWidth: 180 },
  grow: { flex: 1, minWidth: 220 },
  actions: { display: "flex", gap: 6 }
}));

const fieldTypes = [
  ["text", "Texto"], ["number", "Número"], ["date", "Data"],
  ["select", "Lista"], ["multiselect", "Seleção múltipla"]
];

const TicketCustomFields = () => {
  const classes = useStyles();
  const [fields, setFields] = useState([]);
  const [editing, setEditing] = useState(null);
  const [name, setName] = useState("");
  const [fieldType, setFieldType] = useState("text");
  const [options, setOptions] = useState("");
  const [required, setRequired] = useState(false);

  const load = async () => {
    try { setFields((await api.get("/ticket-custom-fields")).data); }
    catch (err) { toastError(err); }
  };
  useEffect(() => { load(); }, []);

  const reset = () => { setEditing(null); setName(""); setFieldType("text"); setOptions(""); setRequired(false); };
  const edit = field => {
    setEditing(field); setName(field.name); setFieldType(field.fieldType);
    try { setOptions(JSON.parse(field.options || "[]").join(", ")); } catch (_) { setOptions(""); }
    setRequired(field.required);
  };
  const save = async () => {
    try {
      const payload = {
        name, fieldType,
        options: options.split(",").map(item => item.trim()).filter(Boolean),
        required, active: editing ? editing.active : true,
        position: editing ? editing.position : fields.length
      };
      if (editing) await api.put(`/ticket-custom-fields/${editing.id}`, payload);
      else await api.post("/ticket-custom-fields", payload);
      reset(); load();
    } catch (err) { toastError(err); }
  };
  const toggle = async field => {
    let parsed = [];
    try { parsed = JSON.parse(field.options || "[]"); } catch (_) {}
    try {
      await api.put(`/ticket-custom-fields/${field.id}`, { ...field, options: parsed, active: !field.active });
      load();
    } catch (err) { toastError(err); }
  };

  return <MainContainer>
    <MainHeader><Title>Campos personalizados</Title></MainHeader>
    <div className={classes.content}>
      <Paper variant="outlined" className={classes.form}>
        <TextField className={classes.grow} label="Nome do campo" value={name} onChange={event => setName(event.target.value)} />
        <FormControl className={classes.input}>
          <InputLabel>Tipo</InputLabel>
          <Select value={fieldType} onChange={event => setFieldType(event.target.value)}>
            {fieldTypes.map(([value, label]) => <MenuItem key={value} value={value}>{label}</MenuItem>)}
          </Select>
        </FormControl>
        {(fieldType === "select" || fieldType === "multiselect") && <TextField className={classes.grow} label="Opções separadas por vírgula" value={options} onChange={event => setOptions(event.target.value)} />}
        <FormControlLabel control={<Checkbox checked={required} onChange={event => setRequired(event.target.checked)} />} label="Obrigatório" />
        <Button variant="contained" color="primary" disabled={!name.trim()} onClick={save}>{editing ? "Salvar" : "Adicionar"}</Button>
        {editing && <Button onClick={reset}>Cancelar</Button>}
      </Paper>
      <Paper variant="outlined">
        <Table size="small"><TableHead><TableRow><TableCell>Campo</TableCell><TableCell>Tipo</TableCell><TableCell>Obrigatório</TableCell><TableCell>Status</TableCell><TableCell>Ações</TableCell></TableRow></TableHead>
          <TableBody>{fields.map(field => <TableRow key={field.id}>
            <TableCell><Typography>{field.name}</Typography></TableCell><TableCell>{fieldTypes.find(item => item[0] === field.fieldType)?.[1]}</TableCell>
            <TableCell>{field.required ? "Sim" : "Não"}</TableCell><TableCell>{field.active ? "Ativo" : "Arquivado"}</TableCell>
            <TableCell><div className={classes.actions}><Button size="small" onClick={() => edit(field)}>Editar</Button><Button size="small" onClick={() => toggle(field)}>{field.active ? "Arquivar" : "Ativar"}</Button></div></TableCell>
          </TableRow>)}</TableBody>
        </Table>
      </Paper>
    </div>
  </MainContainer>;
};
export default TicketCustomFields;
